export enum Types {
	GERAR_RENACH_MUDANCA_CATEGORIA = '@cnh/GERAR_RENACH_MUDANCA_CATEGORIA',
	GERAR_RENACH_MUDANCA_CATEGORIA_SUCCESS = '@cnh/GERAR_RENACH_MUDANCA_CATEGORIA_SUCCESS',
	GERAR_RENACH_MUDANCA_CATEGORIA_FAILURE = '@cnh/GERAR_RENACH_MUDANCA_CATEGORIA_FAILURE',
}

export interface gerarRenach {
	status: number;
	data: null | IDadosRenach;
}
export interface IRequestGerarRenach {
	bairro: string;
	categoriaAtual: string;
	categoriaPretendida: string;
	celular: string;
	cep: string;
	cnhDigital: string;
	codigoEntidade: string;
	codigoVerificador: string;
	complemento: string;
	cpf: string;
	dataNascimento: string;
	dataPrimeiraHabilitacao: string;
	dddCelular: string;
	email: string;
	logradouro: string;
	nacionalidade: string;
	naturalidade: string;
	necessidadeVeiculoAdaptado: string;
	nome: string;
	nomeMae: string;
	nomePai: string;
	numCarteiraMilitar: string;
	numDocumento: string;
	numPGU: string;
	numRNE: string;
	numRegistro: string;
	numero: string;
	orgaoDocumento: string;
	orgaoRNE: string;
	pretendeAtividadeRemunerada: string;
	sexo: string;
	tipoDocumento: string;
	ufDocumento: string;
	ufRNE: string;
}

export interface IDadosRenach {
	codigoInterno: string;
	message: string;
	cpf: string;
	renach: string;
}
